module.exports = __webpack_public_path__ + "static/media/Tip.cae50e2e.png";